import React from 'react';

import { FileText, FileImage, FileSpreadsheet, File } from 'lucide-react';

import { Header, IconWrapper, FileInfo, FileName, FileMeta } from './Preview.styles';

const getIcon = (extension) => {
  switch (extension) {
    case 'pdf':
      return <FileText size={26} color="#EA4335" />;

    case 'png':
    case 'jpg':
    case 'jpeg':
      return <FileImage size={26} color="#34A853" />;

    case 'xls':
    case 'xlsx':
      return <FileSpreadsheet size={26} color="#1D6F42" />;

    default:
      return <File size={26} color="#4285F4" />;
  }
};

const PreviewHeader = ({ file }) => {
  if (!file) return null;

  return (
    <Header>
      <IconWrapper>{getIcon(file.extension)}</IconWrapper>

      <FileInfo>
        <FileName>{file.name}</FileName>

        <FileMeta>
          {file.size} • {file.modified}
        </FileMeta>
      </FileInfo>
    </Header>
  );
};

export default PreviewHeader;
